import { Color as PersonaColor } from '@persona-id/design-tokens';
import Color from 'color';
import { ComponentPropsWithoutRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';

import { BASE } from 'design-system/variables/spacing';
import { TransitionDuration } from 'design-system/variables/transitions';
import IconX from 'images/icons/inquiry/nav-x.svg';
import { Z_INDICES } from 'verify/styles/variables';

interface PopupBackdropProps extends ComponentPropsWithoutRef<'div'> {
  visible: boolean;
  onClose?: () => unknown;
}

const BackdropBackground = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${Z_INDICES.popupBackdrop};

  &.backdrop-enter {
    background-color: rgba(0, 0, 0, 0);
    pointer-events: none;
  }

  &.backdrop-enter-active,
  &.backdrop-enter-done {
    background-color: rgba(0, 0, 0, 0.85);
    transition: background-color ${TransitionDuration.Fast};
    pointer-events: unset;
  }

  &.backdrop-exit {
    background-color: rgba(0, 0, 0, 0.85);
    pointer-events: unset;
  }
  &.backdrop-exit-active {
    background-color: rgba(0, 0, 0, 0);
    transition: background-color ${TransitionDuration.Fast};
    pointer-events: none;
  }
`;

// copied from NavBar NavOption
const CloseButton = styled('button')<{ iconColor?: string }>`
  position: absolute;
  right: 24px;
  top: 24px;
  cursor: pointer;
  pointer-events: auto;
  background: none;

  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;

  margin: -${BASE / 1.5}px;
  padding: ${BASE / 1.5}px;
  border-radius: ${({ theme }) => theme.borderRadius};
  outline: 0 !important;

  transition:
    box-shadow ${TransitionDuration.Fast},
    background-color ${TransitionDuration.Fast};
  box-shadow: 0 0 0 2px transparent;

  :hover:not(:disabled) {
    background-color: ${Color(PersonaColor.CoreSlate300).fade(0.5).rgb().string()};
  }

  :focus:not(:disabled):not(:active) {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colorPrimary};
  }

  :active:not(:disabled) {
    background-color: ${Color(PersonaColor.CoreSlate400).fade(0.5).rgb().string()};
  }

  svg path {
    stroke: ${PersonaColor.PrimaryWhite};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.25;
  }
`;
const PopupBackdrop = (props: PopupBackdropProps) => {
  const onClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    props.onClose?.();
  };

  return (
    <CSSTransition
      in={props.visible}
      timeout={{
        enter: 200,
        exit: 200,
      }}
      mountOnEnter={true}
      unmountOnExit={true}
      classNames='backdrop'
    >
      <BackdropBackground>
        <CloseButton id='popup_backdrop__close' onClick={onClose}>
          <IconX />
        </CloseButton>
        {props.children}
      </BackdropBackground>
    </CSSTransition>
  );
};

export default PopupBackdrop;
